module.exports = __webpack_public_path__ + "images/5047e11a8dcfef22290871bef2a29dae.jpg";